import * as React from 'react';

function SvgArrowRightCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable={false}
      {...props}
    >
      <circle cx={12} cy={12} r={10} />
      <path d="M12 16l4-4-4-4M8 12h8" />
    </svg>
  );
}

export default SvgArrowRightCircle;
